import React from "react";
import { Navigate } from "react-router-dom";

function PrivateRoute({ Component, role }) {
  const userRole = localStorage.getItem("userRole");

  if (!userRole) {
    return <Navigate to="/" />;
  }

  if (userRole !== role && userRole !== "admin") {
    return <Navigate to="/" />;
  }

  return <Component />;
}
export default PrivateRoute;